import { Location } from "@angular/common";
import { HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { Component, OnInit, OnDestroy } from "@angular/core";
import { FormArray, FormControl, FormGroup, Validators } from "@angular/forms";
import { fadeInRightAnimation } from "src/@fury/animations/fade-in-right.animation";
import { fadeInUpAnimation } from "src/@fury/animations/fade-in-up.animation";
import { scaleInAnimation } from "src/@fury/animations/scale-in.animation";
import { ErrorType } from "src/app/enums/error-type.enum";
import { ApiService } from "src/app/services/api.service";
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import endpoints from "src/app/helpers/endpoints";

@Component({
  selector: "fury-global-ip-add-edit",
  templateUrl: "./global-ip-add-edit.component.html",
  styleUrls: ["./global-ip-add-edit.component.scss"],
  animations: [fadeInUpAnimation, fadeInRightAnimation, scaleInAnimation],
})
export class GlobalIpAddEditComponent implements OnInit, OnDestroy {
  ipAddressForm!: FormGroup;
  ngUnsubscribe = new Subject<void>();

  constructor(private apiService: ApiService, public location: Location) {}

  ngOnInit(): void {
    this.formInit();
    this.getGlobalIpAddress();
  }

  formInit() {
    this.ipAddressForm = new FormGroup({
      ipAddress: new FormArray([]),
    });
  }

  get ipAddress() {
    return this.ipAddressForm.get("ipAddress") as FormArray;
  }

  addField() {
    const newField = new FormControl("", [
      Validators.required,
      Validators.pattern(
        /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
      ),
    ]);
    this.ipAddress.push(newField);
  }

  removeField(index: number) {
    this.ipAddress.removeAt(index);
  }
  getGlobalIpAddress() {
    this.apiService
      .get(endpoints.globalIpAddress.getGlobalIpAddress)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((res: HttpResponse<any>) => {
        if (res.body) {
          res.body?.globalAccessIps?.forEach((item) => {
            this.ipAddress.push(
              new FormControl(item, [
                Validators.required,
                Validators.pattern(
                  /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/
                ),
              ])
            );
          });
        }
      });
  }

  save() {
    if (this.ipAddressForm.valid) {
      let value = this.ipAddressForm.value?.ipAddress;
      this.apiService
        .post(endpoints.globalIpAddress.saveGlobalIpAddress, {
          globalAccessIps: value,
        })
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe({
          next: (res: HttpResponse<any>) => {
            if (res.body) {
              this.apiService.alert(res.body.message, ErrorType.Success);
              this.location.back();
            }
          },
          error: (err: HttpErrorResponse) => {
            this.apiService.alert(err.message, ErrorType.Error);
          },
        });
    } else {
      this.ipAddressForm.markAllAsTouched();
    }
  }
  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
